module.exports = __webpack_public_path__ + "img/search-b.58be9813.png";